import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { ErrorBox, Spinner } from "@/components/Bits";
import { useAdminGet } from "@/pages/admin/SuperAdmin";

const rateColor = (r) => (r >= 70 ? "text-[#B7F52A]" : r >= 40 ? "text-amber-300" : "text-red-300");

function Growth({ n, pct }) {
  const I = n > 0 ? TrendingUp : n < 0 ? TrendingDown : Minus;
  const c = n > 0 ? "text-[#B7F52A]" : n < 0 ? "text-red-300" : "text-slate-400";
  return <span className={`inline-flex items-center gap-1 font-bold ${c}`}><I size={13} />{n > 0 ? `+${n}` : n}{pct !== null && pct !== undefined ? ` (${pct > 0 ? "+" : ""}${pct} %)` : ""}</span>;
}

function Cell({ m }) {
  return (
    <td className="px-2 py-2 text-center align-top">
      <span className={`block font-mono-num text-sm font-bold ${rateColor(m.rate)}`}>{m.members ? `${m.rate} %` : "—"}</span>
      <span className="block text-[10px] text-slate-500">{m.active}/{m.members}{m.joined ? ` · +${m.joined}` : ""}</span>
    </td>
  );
}

export default function CorporateOverview({ onExpired }) {
  const { data, error } = useAdminGet("/superadmin/corporate-overview?months=6", onExpired);
  if (error) return <ErrorBox message={error} />;
  if (!data) return <Spinner />;
  if (!data.leagues.length) return null;
  const tot = data.leagues.reduce((a, l) => ({ members: a.members + l.members, growth: a.growth + l.growth }), { members: 0, growth: 0 });
  return (
    <section className="mpl-card p-4" data-testid="corp-overview">
      <div className="mb-3 flex flex-wrap items-end justify-between gap-2">
        <div>
          <h2 className="text-base font-bold">Tableau clients</h2>
          <p className="text-xs text-slate-400">Participation par mois (joueurs ayant fait au moins un prono / membres), nouveaux membres et croissance par rapport au mois dernier.</p>
        </div>
        <p className="text-sm" data-testid="corp-overview-total"><b>{data.leagues.length}</b> ligue(s) · <b>{tot.members}</b> membres · <Growth n={tot.growth} /></p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[760px] text-xs">
          <thead><tr className="text-left text-slate-500">
            <th className="py-2 pr-2 font-semibold">Ligue</th><th className="px-2 text-center font-semibold">Membres</th><th className="px-2 text-center font-semibold">Ce mois</th>
            {data.months.map((m) => <th key={m} className="px-2 text-center font-semibold">{m.replace(/ \d{4}$/, "")}</th>)}
          </tr></thead>
          <tbody>{data.leagues.map((l) => (
            <tr key={l.id} className="border-t border-white/[0.06]" data-testid={`corp-overview-row-${l.id}`}>
              <td className="py-2 pr-2 align-top">
                <span className="flex items-center gap-2"><span className="h-3 w-3 shrink-0 rounded-full" style={{ background: l.brand?.primary }} /><b className="text-sm text-white">{l.name}</b></span>
                <span className="text-[10px] text-slate-500">{!l.ready ? "En attente de l'organisateur" : l.archived ? "Archivée" : "Active"}</span>
              </td>
              <td className="px-2 py-2 text-center align-top font-mono-num text-sm">{l.members}<span className="text-slate-500">{l.max_members ? `/${l.max_members}` : " · illimité"}</span></td>
              <td className="px-2 py-2 text-center align-top" data-testid={`corp-overview-growth-${l.id}`}><Growth n={l.growth} pct={l.growth_pct} /></td>
              {l.months.map((m) => <Cell key={m.key} m={m} />)}
            </tr>))}</tbody>
        </table>
      </div>
    </section>
  );
}
